// Plain constants and helpers shared by the API routes and the changelog UI.
// Kept free of any zod import: this module is reachable from a client
// component, and zod's `allowsEval` feature probe calls `new Function`, which
// a strict CSP reports as a violation on every page that ships it.
export const CHANGELOG_APPS = ["loyalty_referrals", "product_options", "ai_seo"];
export const CHANGELOG_TYPES = ["fix", "new", "improvement"];

// Matches the locales registered in src/lib/i18n.js
export const CHANGELOG_LOCALES = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "pt-br", label: "Português (BR)" },
  { code: "nl", label: "Nederlands" },
  { code: "pl", label: "Polski" },
  { code: "cs", label: "Čeština" },
  { code: "da", label: "Dansk" },
  { code: "fi", label: "Suomi" },
  { code: "nb", label: "Norsk" },
  { code: "sv", label: "Svenska" },
  { code: "tr", label: "Türkçe" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "zh-cn", label: "简体中文" },
  { code: "zh-tw", label: "繁體中文" },
  { code: "th", label: "ไทย" },
];

export const CHANGELOG_LOCALE_CODES = CHANGELOG_LOCALES.map((l) => l.code);

// Pick the best translation for a given locale, falling back to the entry's
// default title/bullets. Used by the public page.
export function resolveLocalized(entry, locale) {
  const translations = entry?.translations || {};
  const normalized = (locale || "").toLowerCase();
  const candidates = [normalized, normalized.split("-")[0]].filter(Boolean);
  for (const key of candidates) {
    const t = translations[key];
    if (t && t.title) {
      return {
        title: t.title,
        bullets:
          Array.isArray(t.bullets) && t.bullets.length > 0
            ? t.bullets
            : entry.bullets,
      };
    }
  }
  return { title: entry.title, bullets: entry.bullets };
}

export const APP_LABELS = {
  loyalty_referrals: "Loyalty & Referrals",
  product_options: "Product Options",
  ai_seo: "AI SEO",
};

export const TYPE_LABELS = {
  fix: "Fix",
  new: "New Features",
  improvement: "Improvement",
};

export function normalizeAppSlug(input) {
  if (!input) return null;
  const v = String(input).toLowerCase().replace(/[\s-]+/g, "_");
  const map = {
    loyalty: "loyalty_referrals",
    "loyalty&referrals": "loyalty_referrals",
    loyalty_and_referrals: "loyalty_referrals",
    loyalty_referrals: "loyalty_referrals",
    product_options: "product_options",
    options: "product_options",
    ai_seo: "ai_seo",
    seo: "ai_seo",
    ai: "ai_seo",
  };
  return map[v] || (CHANGELOG_APPS.includes(v) ? v : null);
}

export function normalizeType(input) {
  if (!input) return null;
  const v = String(input).toLowerCase();
  return CHANGELOG_TYPES.includes(v) ? v : null;
}
